import { setMailboxMessageConfiguration } from 'owa-options-core';
import ReadReceiptOptionState from '../store/schema/ReadReceiptOptionState';
import store from '../store/store';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
import MailboxMessageConfigurationOptions from 'owa-service/lib/contract/MailboxMessageConfigurationOptions';

export interface SaveReadReceiptOptionState {
    optionState: ReadReceiptOptionState;
    userOptions: UserOptionsType;
}

export default select<SaveReadReceiptOptionState>({
    optionState: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})(
    action('saveReadReceiptOption')(async function saveReadReceiptOption(
        state?: SaveReadReceiptOptionState
    ) {
        let { optionState, userOptions } = state;

        userOptions.ReadReceipt = optionState.readReceiptResponse;

        // VSO: 13588 -- Currently, there's a bug in the generated owa-service code, which we need to work around.
        // The client code uses string literal types, but the server expects integer values
        let optionId: number;

        switch (optionState.readReceiptResponse) {
            case 'DoNotAutomaticallySend':
                optionId = 0;
                break;
            case 'AlwaysSend':
                optionId = 1;
                break;
            case 'NeverSend':
                optionId = 2;
                break;
        }

        await setMailboxMessageConfiguration(<MailboxMessageConfigurationOptions>(<any>{
            ReadReceiptResponse: optionId,
        }));
    })
);
